<div [ngClass]="{ 'qc-wrapper': isActive$ | async }">
	<cv-modal></cv-modal>
	<!-- header -->
	<ng-container *ngIf="!isInsideIframe">
		<cv-header
			*ngIf="(isActive$ | async)"
			[@uiConfigHideComponent]="{
					value: isMainComponentVisible[uiConfigComponent.HEADER]?.show ? 'open' : 'closed'
				}"
			(DisplayNav)="toggleLeftNav()"> </cv-header>
	</ng-container>
	<!-- Breadcrumb -->
	<cv-breadcrumb
		*ngIf="(isActive$ | async)"
		(toggleSubContentPanel)="toggleSubContentPanel($event)"
	></cv-breadcrumb>
	<div class="qc-content"
		 [ngClass]="{
		 	'is-breadcrumb-hidden': isBreadcrumbHidden,
		 	'is-full-height': isInsideIframe,
		 	'is-only-header': (isMainComponentVisible[uiConfigComponent.HEADER]?.show && !isMainComponentVisible[uiConfigComponent.FOOTER]?.show) || isOnSmartAssign,
		 	'is-only-footer': (isMainComponentVisible[uiConfigComponent.FOOTER]?.show && !isMainComponentVisible[uiConfigComponent.HEADER]?.show),
		 	'left-panel-version': changePanelPosition
		 }">
		<!-- left content -->
		<cv-left-nav
			*ngIf="(isActive$ | async) && !showNewMenu && !hideMenu"
			#leftNavComponent
			[uiConfigStyle]="isMainComponentVisible[uiConfigComponent.LEFT_MENU]"
			[width]="225"
			[isOpen]="openLeftNav"
			[items]="navItems$ | async"
			(onExpand)="toggleLeftNav()"
			(onCollapse)="toggleLeftNav()"
			(onRouteChange)="onNavItemClick($event)"
		>
		</cv-left-nav>
		<cv-left-nav-new
				*ngIf="(isActive$ | async) && showNewMenu && !hideMenu"
				#newLeftNavComponent
				[uiConfigStyle]="isMainComponentVisible[uiConfigComponent.LEFT_MENU]"
				[width]="260"
				[isOpen]="openLeftNav"
				[scrollableInto]="true"
				[items]="navItems$ | async"
				(onExpand)="toggleLeftNav()"
				(onCollapse)="toggleLeftNav()"
				(onRouteChange)="onNavItemClick($event)"
		>
		</cv-left-nav-new>
		<!-- Main content -->
		<main [ngClass]="{ 'qc-content__main-amc': isActive$ | async, 'qc-content__main': true, 'left-nav-open': openLeftNav }">
			<cv-content-loader></cv-content-loader>
			<router-outlet></router-outlet>
		</main>
		<!-- right content -->
		<cv-sub-content
			*ngIf="(isActive$ | async)"
			[isSubContentPanelOpen]="isSubContentPanelOpen"
			class="qc-content__main-sides {{currentModule}}"
			[@sideExpansion]="{
				value: isSubContentPanelOpen ? 'isOpen' : 'isClose',
				params: { flex: subContentPanelFlexWidth }
			}"
		>
		</cv-sub-content>
		<cv-invision-ux-chatbot *ngIf="showChatbot"></cv-invision-ux-chatbot>
	</div>
	<!-- footer -->
	<ng-container *ngIf="!isInsideIframe">
		<cv-footer
			*ngIf="(isActive$ | async)"
			[uiConfigStyle]="isMainComponentVisible[uiConfigComponent.FOOTER]"
			[@uiConfigHideComponent]="{
					value: isMainComponentVisible[uiConfigComponent.FOOTER]?.show ? 'open' : 'closed'
				}"
			></cv-footer>
	</ng-container>
</div>
